export default {
  name: "",
  lists: [],
};
